import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=635758f6&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=635758f6&prod&lang=css"
import style1 from "./profile.vue?vue&type=style&index=1&id=635758f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635758f6",
  null
  
)

export default component.exports